import { AbstractCustomField } from '@/components/Fields/dataObjects/AbstractCustomField'
import { CustomFieldCustomFieldOptionInput, CustomFieldType } from '@/gql/graphql'

export class FileUpload extends AbstractCustomField {
  fieldType: CustomFieldType = CustomFieldType.FileUpload

  optionsForGraphQL(): CustomFieldCustomFieldOptionInput[] {
    // File upload does not have options
    return []
  }
}
